import type { RefObject } from 'react'
import { useEffect } from 'react'

type UseLoadMoreWhenNotScrollableProps = {
  itemsLength: number
  isLoading?: boolean
  hasNextPage: boolean
  scrollableContentRef: RefObject<any>
  loadMore: () => void
}

// Force loading more when there are no enough items to make the container scrollable
// (only scrolling to the very bottom triggers InfiniteScroll next function)
// https://github.com/ankeetmaini/react-infinite-scroll-component/issues/309

export const useLoadMoreWhenNotScrollable = ({
  itemsLength,
  isLoading = false,
  hasNextPage,
  scrollableContentRef,
  loadMore,
}: UseLoadMoreWhenNotScrollableProps) => {
  useEffect(() => {
    const isScrollable = scrollableContentRef.current
      ? scrollableContentRef.current?.scrollHeight > scrollableContentRef.current?.clientHeight
      : false

    if (!isLoading && hasNextPage && !isScrollable) {
      loadMore()
    }
  }, [itemsLength, isLoading, hasNextPage, scrollableContentRef, loadMore])
}
